import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Login from "../components/Login/Login";
import {
  fetchAccessToken,
  verifyOtp,
  resendOtp,
  fetchUserData
} from "../actions/user";

const mapStateToProps = (state) => {
  const { login } = state;
  const {
    isFetching,
    otpToken,
    accessToken,
    refreshToken,
    errorMessage,
    screen_message,
    otpAttemptCount
  } = login || {
    isFetching: false,
    otpToken: null,
    accessToken: null,
    refreshToken: null,
    errorMessage: null,
    screen_message: "",
    otpAttemptCount: 0
  };

  return {
    isFetching,
    otpToken,
    accessToken,
    refreshToken,
    errorMessage,
    screen_message,
    otpAttemptCount
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAccessToken,
      verifyOtp,
      resendOtp,
      fetchUserData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
